"use strict";
function toDot(nba) {
    var alphabet = nba.alphabet, states = nba.states, transition = nba.transition, initial = nba.initial, accepting = nba.accepting;
    var invMap = [];
    var nodes = states.map(function (q, i) {
        invMap[q] = i;
        if (accepting.indexOf(q) >= 0) {
            return "q" + i + " [shape = doublecircle];";
        }
        else {
            return "q" + i + ";";
        }
    }).join('\n');
    var edgesarr = [];
    for (var q in transition) {
        var map = transition[q];
        // 同じtransitionはまとめる
        var table = {};
        for (var a in map) {
            for (var _i = 0, _a = map[a]; _i < _a.length; _i++) {
                var q2 = _a[_i];
                if (!(q2 in table)) {
                    table[q2] = [];
                }
                table[q2].push("{" + a + "}");
            }
        }
        for (var q2 in table) {
            var qs = table[q2].join(',');
            var e = "q" + invMap[q] + " -> q" + invMap[q2] + " [label=\"" + qs + "\"];";
            edgesarr.push(e);
        }
    }
    var edges = edgesarr.join('\n');
    return "digraph {\n    graph [\n        rankdir = LR;\n    ];\n    node [\n        shape = circle;\n    ];\n\n    \"\" [shape = none];\n    \"\" -> q0;\n\n    " + nodes + "\n\n    " + edges + "\n}";
}
exports.toDot = toDot;



/*****************
 ** WEBPACK FOOTER
 ** ./dist/dot.js
 ** module id = 28
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ./dist/dot.js
 ** module id = 28
 ** module chunks = 1
 **/